import { connect, ConnectedProps } from 'react-redux';
import {
  mapDispatchToProps,
  mapStateToProps,
} from './call-logs-prospect-drawer-header-map';

export const callLogsProspectDrawerHeaderConnector = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export type CallLogsProspectDrawerHeaderReduxProps = ConnectedProps<
  typeof callLogsProspectDrawerHeaderConnector
>;
